var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCdcIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52608",
    "data-name": "Group 52608",
    transform: "translate(-162 -3176.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18504",
    "data-name": "Rectangle 18504",
    transform: "translate(162 3176.968)",
    fill: "none",
    stroke: "#93a750",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 83,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_21_",
    "data-name": "svgexport-7 (21)",
    transform: "translate(170.678 3186.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91046",
    "data-name": "Path 91046",
    d: "M13,23H37.286v6.072H13Z",
    transform: "translate(3.625 10.357)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91047",
    "data-name": "Path 91047",
    d: "M31,23h6.072v6.072H31Z",
    transform: "translate(12.947 10.357)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91048",
    "data-name": "Path 91048",
    d: "M31,29h6.072v6.072H31Z",
    transform: "translate(12.947 13.465)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91049",
    "data-name": "Path 91049",
    d: "M37.072,23.071V18.518A1.518,1.518,0,0,0,35.554,17H31v6.071Z",
    transform: "translate(12.947 7.25)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91050",
    "data-name": "Path 91050",
    d: "M34.518,14.941H45.559A6.071,6.071,0,0,0,44.751,14L34.6,4.442A6.072,6.072,0,0,0,33,3.39V13.423A1.518,1.518,0,0,0,34.518,14.941Z",
    transform: "translate(13.983 0.202)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91051",
    "data-name": "Path 91051",
    d: "M21,35v3.036a1.518,1.518,0,0,0,1.518,1.518H40.732a1.518,1.518,0,0,0,1.518-1.518V35Z",
    transform: "translate(7.768 16.572)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91052",
    "data-name": "Path 91052",
    d: "M48.5,18.179a4.554,4.554,0,0,1-4.554-4.554V3H12.071A6.071,6.071,0,0,0,6,9.071V60.679a6.071,6.071,0,0,0,6.071,6.071h42.5a6.071,6.071,0,0,0,6.071-6.071V18.634c0-.152-.035-.3-.047-.455ZM53.054,31.84V54.608A4.554,4.554,0,0,1,48.5,59.161H30.286a4.554,4.554,0,0,1-4.554-4.554V51.572H18.143a4.554,4.554,0,0,1-4.554-4.554V25.768a4.554,4.554,0,0,1,4.554-4.554H48.5a4.554,4.554,0,0,1,4.554,4.554Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91053",
    "data-name": "Path 91053",
    d: "M37.286,35.072V29H13v4.554a1.518,1.518,0,0,0,1.518,1.518Z",
    transform: "translate(3.625 13.465)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91054",
    "data-name": "Path 91054",
    d: "M37.286,17H14.518A1.518,1.518,0,0,0,13,18.518v4.554H37.286Z",
    transform: "translate(3.625 7.25)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("text", {
    id: "CDC",
    transform: "translate(11.322 11.416)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "Impact",
    letterSpacing: "0.035em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CDC")), /*#__PURE__*/React.createElement("text", {
    id: "_statement",
    "data-name": " statement",
    transform: "translate(14.322 18.416)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "Impact",
    letterSpacing: "0.035em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, " statement"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdcIcon);
export default __webpack_public_path__ + "static/media/CDCIcon.cc7add23ce360054b1338bd6c58027f0.svg";
export { ForwardRef as ReactComponent };